module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Mashvisor","description":"Your Search for Real Estate Investment Property Begins and Ends Here. Use analytics to Find Traditional or Airbnb Investment Property in a Matter of Minutes.","short_name":"Mashvisor","start_url":"/","background_color":"#fff","theme_color":"#fff","display":"minimal-ui","icon":"src/images/mashvisor_icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e9f218f1fe42ad867a99ed2586564835"},
    },{
      plugin: require('../plugins/gatsby-plugin-mv-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-56828631-1","head":true,"includeInDevelopment":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
